import { useTranslation } from 'react-i18next'

function Subscribe() {
  const { t } = useTranslation()

  return (
    <section className="tc-subscribe-style6">
      <div className="container">
        <div className="content">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="form">
                <div className="section-title">
                  <h2 className="js-splittext-lines marcellus">
                    {t('subscribe.titleFirst')} <span className="color-green1">{t('subscribe.titleHighlight')}</span> {t('subscribe.titleLast')}
                  </h2>
                  <p className="fsz-18 mt-30 color-666 marcellus">
                    {t('subscribe.description')}
                  </p>
                </div>
                <div className="form-group wow fadeInUp slow" data-wow-delay="0.2s">
                  <span className="icon fsz-20 me-2">
                    <i className="fal fa-envelope"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control marcellus"
                    placeholder={t('subscribe.placeholder')}
                  />
                  <button className="marcellus">{t('subscribe.button')}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Subscribe
